export default __webpack_public_path__ + "static/media/coming-soon.e0c3c7cb.png";